import React from 'react';
import { ReactCompareSlider, ReactCompareSliderImage } from "react-compare-slider";

const CompareSlider = ({ beforeImage, afterImage, className }) => {
    return (
        <ReactCompareSlider
            position={45}
            itemOne={<ReactCompareSliderImage src={beforeImage} alt="Elegant Finish Painting Our Work Before" loading="lazy" />}
            itemTwo={<ReactCompareSliderImage src={afterImage} alt="Elegant Finish Painting Our Work After" loading="lazy" />}
            className={className} // Pass down the className prop
        />
    );
};

export default CompareSlider;

